import { TFunction } from 'i18next';
import * as React from 'react';

export function IdCardTab({ t }: { t: TFunction }) {
    return <p>{t('views.login.idCard.description')}</p>;
}
